import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
@Component({
  selector: 'app-provider-filter',
  templateUrl: './provider-filter.component.html',
  styleUrls: ['./provider-filter.component.scss']
})
export class ProviderFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listProviderFilter: any[];
  optionSelected: any;

  @Input() providerData: any;
  @Input() providerSelected: any;

  constructor() {
    super();
  }
  ngOnInit() {
  }
  ngOnChanges (changes: SimpleChanges) {
    if ('providerData' in changes) {
      this.listProviderFilter = this.providerData;
      this.optionSelected = this.listProviderFilter ? this.listProviderFilter[0] : null;
    }
    if (this.providerSelected) {
      this.optionSelected = this.providerSelected;
    }
  }

  ngOnDestroy(): void {
  }

  reset() {
    this.optionSelected = this.listProviderFilter ? this.listProviderFilter[0] : null;
  }
}
